import React from "react";
import { connect } from "react-redux";
import { StaticGoogleMap, Marker } from "react-static-google-map";
import PropTypes from "prop-types";
const RichContentMap = props => {
  return /*#__PURE__*/React.createElement(StaticGoogleMap, {
    size: "400x400",
    apiKey: props.apikey
  }, /*#__PURE__*/React.createElement(Marker, {
    location: props.destination.latitude + "," + props.destination.longitude,
    iconURL: "https://www.dpd.co.uk/ang-component/webcomponents/general/img/google-map-marker-blue.png"
  }), props.origin ? /*#__PURE__*/React.createElement(Marker, {
    location: props.origin.latitude + "," + props.origin.longitude,
    iconURL: "https://www.dpd.co.uk/ang-component/webcomponents/general/img/google-map-marker-red.png"
  }) : null);
};
RichContentMap.propTypes = {
  apikey: PropTypes.string,
  origin: PropTypes.object,
  destination: PropTypes.object
};
function mapStateToProps(state) {
  return state.apikey;
}
export default connect(mapStateToProps)(RichContentMap);